import PreviewProfileLayout from './PreviewProfileLayout';

export default PreviewProfileLayout;
